import React from "react";
import Grid from "@mui/material/Grid2";
import { Typography } from "@mui/material";
import benefitsTabData from "../../data/benefitsTabData.json";
import ArrowCircleRightIcon from "@mui/icons-material/ArrowCircleRight";
import { styled } from "@mui/material/styles";
import arrow from "../../assets/images/product-arrows/ic_arrow-core.svg";

const PREFIX = "BenefitsSection";
const classes = {
  productTabsContainer: `${PREFIX}-productTabsContainer`,
  backgroundDesign2: `${PREFIX}-backgroundDesign2`,
  mainHeadingGrid: `${PREFIX}-mainHeadingGrid`,
  mainHeading: `${PREFIX}-mainHeading`,
  talkDescriptionGrid: `${PREFIX}-talkDescriptionGrid`,
  mainTalkDescriptionGrid: `${PREFIX}-mainTalkDescriptionGrid`,
  productTabsDesc: `${PREFIX}-productTabsDesc`,
  benefitItem: `${PREFIX}-benefitItem`,
  benefitHeading: `${PREFIX}-benefitHeading`,
};

const StyledGrid = styled(Grid)(({ theme }) => ({
  [`& .${classes.productTabsContainer}`]: {
    width: "100%",
    marginTop: "2rem",
    padding: "2.5rem",
  },
  [`& .${classes.backgroundDesign2}`]: {
    width: "100%",
    backgroundColor: "white",
  },
  [`& .${classes.mainHeadingGrid}`]: {
    display: "flex",
    fontFamily: "AvenirLTStd-Roman",
    justifyContent: "left",
    padding: "1rem",
    backgroundColor: "white",
    backgroundSize: "contain",
  },
  [`& .${classes.mainHeading}`]: {
    fontSize: 24,
    fontWeight: "bold",
    width: "90%",
    color: "#223140",
    fontFamily: "AvenirLTStd-Book",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      marginTop: "1em",
      fontSize: 16,
    },
    [theme.breakpoints.between("sm", "md")]: {
      padding: "2em 1em 1em 1em",
      fontSize: 25,
    },
    [theme.breakpoints.up("md")]: {
      fontSize: 25,
    },
  },
  [`& .${classes.talkDescriptionGrid}`]: {
    padding: "1rem",
    display: "flex",
    fontFamily: "AvenirLTStd-Book",
    flexDirection: "column",
    alignItems: "left",
    fontSize: 24,
    [theme.breakpoints.down("sm")]: {
      fontSize: 18,
    },
  },
  [`& .${classes.mainTalkDescriptionGrid}`]: {
    fontFamily: "AvenirLTStd-Book",
    marginBottom: "1%",
  },
  [`& .${classes.productTabsDesc}`]: {
    fontFamily: "AvenirLTStd-Book",
    fontSize: 22,
    [theme.breakpoints.down("sm")]: {
      fontSize: 16,
    },
    [theme.breakpoints.between("sm", "md")]: {
      fontSize: 22,
    },
    [theme.breakpoints.up("md")]: {
      fontSize: 22,
    },
  },
  [`& .${classes.benefitItem}`]: {
    gap: "2%",
    display: "flex",
    alignItems: "center",
    marginBottom: "1rem",
  },
  [`& .${classes.benefitHeading}`]: {
    fontWeight: "600",
    fontSize: 24,
    fontFamily: "AvenirLTStd-Roman",
    marginRight: "0.5rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: 18,
    },
  },
}));

const BenefitsSection = () => {
  return (
    <StyledGrid container>
      <Grid
        size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
        className={[
          classes.productTabsContainer,
          classes.backgroundDesign2,
        ].join(" ")}
      >
        <Grid className={classes.mainHeadingGrid}>
          <Typography className={classes.mainHeading}>
            Are you struggling with your Data Quality?
          </Typography>
        </Grid>
        <Grid container className={classes.mainTalkDescriptionGrid}>
          <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
            <Typography className={classes.talkDescriptionGrid}>
              We’ve spoken with 100’s of operators, the same issues always come
              up...
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={4} sx={{ padding: "2rem" }}>
          {benefitsTabData &&
            benefitsTabData.map((item, index) => (
              <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }} key={index}>
                <div className={classes.benefitItem}>
                  <img
                    src={arrow}
                    alt="Arrow"
                    style={{ marginRight: "0.5rem" }}
                  />
                  <Typography className={classes.benefitHeading}>
                    {item.name}
                  </Typography>
                </div>
                <Typography
                  component="div"
                  className={classes.productTabsDesc}
                  sx={{ fontWeight: 100 }}
                >
                  {item.description}
                </Typography>
              </Grid>
            ))}
        </Grid>
      </Grid>
    </StyledGrid>
  );
};

export default BenefitsSection;
